var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_564_9553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33 66C51.2254 66 66 51.2254 66 33C66 14.7746 51.2254 0 33 0C14.7746 0 0 14.7746 0 33C0 51.2254 14.7746 66 33 66Z",
    fill: "#DF2935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.2536 33L48.4886 22.7651C49.9396 21.314 49.9396 18.9623 48.4886 17.5113C47.0375 16.0602 44.6858 16.0602 43.2348 17.5113L32.9998 27.7462L22.7649 17.5113C21.3139 16.0602 18.9621 16.0602 17.5111 17.5113C16.0601 18.9623 16.0601 21.314 17.5111 22.7651L27.7461 33L17.5111 43.2349C16.0601 44.686 16.0601 47.0377 17.5111 48.4887C18.2361 49.2137 19.1873 49.5772 20.1385 49.5772C21.0897 49.5772 22.0399 49.2147 22.7659 48.4887L33.0009 38.2538L43.2358 48.4887C43.9608 49.2137 44.912 49.5772 45.8632 49.5772C46.8144 49.5772 47.7646 49.2147 48.4906 48.4887C49.9416 47.0377 49.9416 44.686 48.4906 43.2349L38.2556 33H38.2536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_9553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCross);
export default __webpack_public_path__ + "static/media/error-cross.45e77ed85dc8e44dc2ea7f42d4a6b537.svg";
export { ForwardRef as ReactComponent };